<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="container mt-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="mb-0">Meus Documentos</h4>
          <button class="btn btn-primary" (click)="carregarDocumentos()">
            <i class="fas fa-sync-alt"></i> Atualizar
          </button>
        </div>
        <div class="card-body">
          <!-- Mensagens de feedback -->
          <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
            {{ successMessage }}
            <button type="button" class="btn-close" (click)="successMessage = ''"></button>
          </div>
          <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
            {{ errorMessage }}
            <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
          </div>

          <!-- Loading spinner -->
          <div *ngIf="loading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>

          <!-- Formulário de Upload -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="mb-0">Enviar Novos Documentos</h5>
            </div>
            <div class="card-body">
              <form (ngSubmit)="onSubmit()">
                <div class="mb-3">
                  <label class="form-label">Selecione os documentos para upload:</label>
                  <div class="document-upload-area">
                    <div class="custom-file-upload">
                      <input 
                        type="file" 
                        class="form-control" 
                        (change)="onFileSelected($event)" 
                        multiple 
                        accept=".pdf,.jpg,.jpeg,.png"
                      >
                    </div>
                    <div class="document-list mt-3">
                      <div 
                        class="document-item d-flex justify-content-between align-items-center p-2 border rounded mb-2" 
                        *ngFor="let doc of novosDocumentos; let i = index"
                      >
                        <span class="text-truncate me-2" style="max-width: 80%;">{{doc.name}}</span>
                        <button 
                          type="button" 
                          class="btn btn-sm btn-danger" 
                          (click)="removeDocumento(i)"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-end">
                  <button 
                    type="submit" 
                    class="btn btn-primary" 
                    [disabled]="novosDocumentos.length === 0 || isUploading"
                  >
                    <span *ngIf="!isUploading">
                      <i class="fas fa-upload me-2"></i>
                      Enviar Documentos
                    </span>
                    <span *ngIf="isUploading" class="d-flex align-items-center">
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Enviando...
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Lista de documentos -->
          <div *ngIf="!loading && documentos.length === 0" class="text-center my-4">
            <p class="text-muted">Nenhum documento encontrado.</p>
          </div>

          <div *ngIf="!loading && documentos.length > 0" class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Nome</th>                
                  <th>Data de Upload</th>           
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let documento of documentos">
                  <td>{{ documento.nome }}</td>          
                  <td>{{ formatarData(documento.dataUpload) }}</td>                 
                  <td>
                    <div class="btn-group">
                      <button 
                        class="btn btn-sm btn-outline-primary" 
                        (click)="baixarDocumento(documento)"
                        title="Baixar documento"
                      >
                        <i class="fas fa-download"></i>
                      </button>
                      <!--<button 
                        class="btn btn-sm btn-outline-danger" 
                        (click)="excluirDocumento(documento)"
                        title="Excluir documento"
                      >
                        <i class="fas fa-trash"></i>
                      </button>-->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 